import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39c2543c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39c2543c')) {
      api.createRecord('39c2543c', component.options)
    } else {
      api.reload('39c2543c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39c2543c&", function () {
      api.rerender('39c2543c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeaseDetailsScreen/index.vue"
export default component.exports